module.exports = __webpack_public_path__ + "img/zip-lines--full.67d916a3.jpg";